import React from "react";
import styles from "./style.module.scss";
import AuthenticatedLayout from "../../../components/Layout/authenticatedLayout";
import RawWinTAX from "../../../components/WinTAX/WinTAXStream";

function WinTAXPage() {
  return (
    <AuthenticatedLayout title={"WinTAX"} showJaguarLogo={false}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <RawWinTAX />
        </div>
      </div>
    </AuthenticatedLayout>
  );
}

export default WinTAXPage;
